<template>
  <div class='box'>
    <div class="ing-item" v-for="(item,index) in wholeCourseChainList" :key="item.id">
      <div class="first-line">
        <div class="scheme-name">
          {{item.patientSchemeName}}
        </div>
        <div class="line-div">
          <img src="@/assets/images/line.png" alt="">
        </div>
        <div class="status-box statu5" v-if="item.status==1">
          未入案
        </div>
        <div class="status-box statu2" v-if="item.status==3">
          评估中
        </div>
        <div class="status-box statu6" v-if="item.status==4">
          待医生确认
        </div>
        <div class="status-box statu4" v-if="item.status==7">
          未开始
        </div>
        <div class="status-box statu1" v-if="item.status==5">
          进行中
        </div>
        <div class="status-box statu3" v-if="item.status==12">
          服务结束
        </div>
      </div>
      <ul class="content-ul">
        <li>
          <span class="title">
            服务团队:
          </span>
          <span class="anser">
            {{item.doctorTeamName}}
          </span>
        </li>
        <li v-if="item.type == 2 || item.type == 1">
          <span class="title">
            服务来源:
          </span>
          <span class="anser">
            {{item.source}}
          </span>
        </li>
        <li>
          <span class="title">
            服务周期:
          </span>
          <span class="anser">
            {{item.period}}
          </span>
        </li>
        <li>
          <span class="title">
            服务时间:
          </span>
          <span class="anser">
            {{item.wholeCourseTime||'--'}}
          </span>
          
        </li>
        <!-- <li>
          <span class="title">
            服务状态:
          </span>
          <span class="anser">
            {{item.wholeCourseTime}}
          </span>
        </li> -->
        <li>
          <span class="title">
            确认时间:
          </span>
          <span class="anser">
            {{item.auditorDoctorTime||'--'}}
          </span>
        </li>
        <li >
          <span class="title" v-if="item.status==3">
            医生拒绝理由:
          </span>
          <span class="anser" v-if="item.status==3">
            {{item.doctorRefuse||'--'}}
          </span> 
        </li>
        <li style="justify-content: end" v-if="routerName!='consultRoom'">
           <div class="edite-btn-box" >
            <!-- <el-button size="mini" type="primary" v-if="item.needAssessment" @click="passPinggu(item)">评估通过</el-button> -->
              <el-popover   trigger="manual" placement='top'  v-model="item.showDate"   title="服务开始时间:" >
               <el-button slot="reference" size="mini" type="primary" class='set-right' @click="showCurDate(index)" v-if="item.needAssessment">评估通过</el-button>
               <div class="choose-date">
                  <el-date-picker  value-format="yyyy-MM-dd" :picker-options="pickerOptions" size="mini" v-model="startDate" type="date" :clearable='false' placeholder="选择日期"> </el-date-picker>
              </div>  
              <el-button style="margin-left:45px" size="mini" @click="hideCurDate(index)" >取消</el-button>
              <el-button  size="mini" type="primary"  @click="passPinggu(item,index)">确认</el-button>
            </el-popover>
            <el-button size="mini" plain v-if="item.experiencePack" @click="refuseMoney(item.wholeCourseId)">发起退款</el-button>
          </div>
        </li>
      </ul>
    </div>
    <div v-show="showFinish" class="ing-item" v-for="item in finishWholeCourseChainList" :key="item.id">
      <div class="first-line">
        <div class="scheme-name">
          {{item.patientSchemeName}}
        </div>
        <div class="line-div">
          <img src="@/assets/images/line.png" alt="">
        </div>
        <div class="status-box statu5" v-if="item.status==1">
          未入案
        </div>
        <div class="status-box statu2" v-if="item.status==3">
          评估中
        </div>
        <div class="status-box statu6" v-if="item.status==4">
          待医生确认
        </div>
        <div class="status-box statu4" v-if="item.status==7">
          未开始
        </div>
        <div class="status-box statu1" v-if="item.status==5">
          进行中
        </div>
        <div class="status-box statu3" v-if="item.status==12">
          服务结束
        </div>
      </div>
      <ul class="content-ul">
        <li>
          <span class="title">
            服务团队:
          </span>
          <span class="anser">
            {{item.doctorTeamName}}
          </span>
        </li>
        <li v-if="item.type == 2 || item.type == 1">
          <span class="title">
            服务来源:
          </span>
          <span class="anser">
            {{item.source}}
          </span>
        </li>
        <li>
          <span class="title">
            服务周期:
          </span>
          <span class="anser">
            {{item.period}}
          </span>
        </li>
        <li>
          <span class="title">
            服务时间:
          </span>
          <span class="anser">
            {{item.wholeCourseTime||'--'}}
          </span>
          
        </li>
        
        <li>
          <span class="title">
            确认时间:
          </span>
          <span class="anser">
            {{item.auditorDoctorTime||'--'}}
          </span>
        </li>
        <li >
          <span class="title" v-if="item.status==3">
            医生拒绝理由:
          </span>
          <span class="anser" v-if="item.status==3">
            {{item.doctorRefuse||'--'}}
          </span>
          <div style="flex:1;text-align:right" v-if="routerName!='consultRoom'">
            <el-button size="mini" type="primary" v-if="item.needAssessment" @click="passPinggu(item)">评估通过</el-button>
            <el-button size="mini" plain v-if="item.experiencePack" @click="refuseMoney(item.wholeCourseId)">发起退款</el-button>
            
          </div>
        </li>
      </ul>
    </div>
    
    <div class="load-more" v-if="!showFinish&&finishWholeCourseChainList.length" @click="showFinish=!showFinish">
      加载已结束的服务链
      <i class="el-icon-arrow-down"></i>
    </div>
    <div v-if="!finishWholeCourseChainList.length&&!wholeCourseChainList.length" class="no-div">
      <img src="@/assets/images/nodata.png" alt="">
      <p>暂无数据</p>
    </div>
    <div class="no-mor" v-if="(showFinish||!finishWholeCourseChainList.length)&&wholeCourseChainList.length">
      所有服务链加载完毕
    </div>

  </div>
</template>

<script>
import { 
  caseSubmitPatient,
  wholeCourseRefund
 } from "../../api/crossApi"; 
 import { 
  getTodayDate 
 } from "@/commen/date.js"; 
export default {
  components:{},
  props:{
    enterCaseData:{
      type:Object,
      default: () => {}
    },
    routerName:{
      type:String,
      default:'Case1Page'
    }
  },
  data(){
    return {
      startDate:getTodayDate(),  
      finishWholeCourseChainList:[],
      wholeCourseChainList:[],
      showFinish:false, 
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;//选当前时间之后的时间
        }
      },
    }
  },
  watch:{
    enterCaseData(newVal){ 
      this.finishWholeCourseChainList =!newVal.finishWholeCourseChainList ? []: newVal.finishWholeCourseChainList;
      this.wholeCourseChainList =!newVal.wholeCourseChainList?[]:newVal.wholeCourseChainList; 
    }
  },  
  methods:{ 
    showCurDate(index){
      // debugger
      this.wholeCourseChainList.map(item=>{
        item.showDate = false
      })
      this.wholeCourseChainList[index].showDate = true
      this.$set(this.wholeCourseChainList, index, this.wholeCourseChainList[index])  
    },
    hideCurDate(index){
      this.wholeCourseChainList[index].showDate = false
      this.$set(this.wholeCourseChainList, index, this.wholeCourseChainList[index])
    },
    refuseMoney(data){
      this.$router.push({path:'/OrderManagement/order',query:{id:data}});
      // this.$confirm('请确认是否发起退款，发起退款后，本次服务立即交结束。', '确认信息', {
        
      //   confirmButtonText: '发起退款',
      //   cancelButtonText: '取消'
      // })
      //   .then(() => {
          
      //     wholeCourseRefund(data).then((result) => {
      //       this.$message.success("操作成功~");
      //       this.$emit('update',2);
      //     }).catch((err) => {
      //     });
      //   })
      //   .catch(action => {
          
      //   });
      
    },
    passPinggu(data,index){  
        let params = {
          wholeCourseId:data.wholeCourseId,
          startDate:this.startDate
        } 
        this.wholeCourseChainList[index].showDate = false
        caseSubmitPatient(params).then((result) => {
          this.$message.success("操作成功~"); 
          this.$emit('update',2);
         }).catch((err) => {}); 
      } 
    }
}
</script>
<style lang="less" scoped>  
.set-right{
  margin-right: 10px;
}
.choose-date{
  margin: 10px 0 15px;
}
 
.box{
  margin: 0 24px;
  .ing-item{
    margin-top: 15px;
    .first-line{
      display: flex;
      align-items: center;
      justify-content:space-between;
      .scheme-name{
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        margin-right: 22px;
      }
      .line-div{
        width: 75%;
        img{
          width: 100%;
          vertical-align: middle;
        }
      }
      .status-box{
        line-height: 22px;
        height: 22px;
        padding: 0 9px;
        border-radius: 11px;
        color: #fff;
        min-inline-size: fit-content;
        &.statu1{
          background: #29767B;
        }
        &.statu2{
          background: #B7E04F;
        }
        &.statu3{
          background: #BBBBBB;
        }
        &.statu4{
          background: #FF7875;
        }
        &.statu5{
          background: #8EB3E3;
        }
        &.statu6{
          background: #E7A44C;
        }
      }
    }
    .content-ul{
      margin-top: 20px;
      li{
        display: flex;
        margin-top: 20px;
        .title{
          width: 84px;
          color: #666666;
          margin-right: 124px;
        }
        .anser{
          width: 171px;
        }
      }
    }
  }
  .load-more{
    color: #1A7BFC;
    margin-top: 30px;
    text-align: center;
    cursor: pointer;
    padding-bottom: 20px;
  }
  .no-mor{
    text-align: center;
    color: #999999;
    margin-top: 30px;
    padding-bottom: 20px;
  }
  .no-div{
    text-align: center;
  }
}
</style>